import type { FaireProductEntity } from "../../entity_types/product";

export const p_hwqap8juzv: FaireProductEntity = {
  token: "p_hwqap8juzv",
  type: "product",
  name: "Gemstone Puffy Heart 15mm – Mini Crystal Hearts for Retail",
  brandToken: "b_at4bwf6pjp",
  brandName: "Keystone Crystals",
  imageUrl:
    "https://cdn.faire.com/fastly/103daf34ec3095e93b5e82d41ad876fe35eab6091857af0a7da414f7cc688498.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/56e707b1e7f7d1942b12aa05406f00e559f5b32f46a40b517d68d21f77c3bf0c.jpeg",
    "https://cdn.faire.com/fastly/51be19ff9c122958a77ad67582618e1867974d275e5e94705b5c63ea7ebb8b41.jpeg",
    "https://cdn.faire.com/fastly/b49a3dc8b04cb0dd10a9645052e0cd79138cdf4333b1bc062c6dba5d29d9abb3.jpeg",
    "https://cdn.faire.com/fastly/610269d31b53656cfcc59c19fafbbc5ed4759942c2d08ad12e35ec1b2fdeceab.jpeg",
    "https://cdn.faire.com/fastly/25ebd7dfd8843a06a06cdae328fe1f6fb8685a4d7717a1b5d55f3bca551d856c.jpeg",
    "https://cdn.faire.com/fastly/c528d2a110769a3b311b106159f9e60ad54841760159fdf239b210e181c36d01.jpeg",
    "https://cdn.faire.com/fastly/60da987778b3ca8a9fa6eac3cb1b6ea2e5505ffd3c6ba67df56a45ac42657a90.jpeg",
    "https://cdn.faire.com/fastly/73469d640418ca6e8be3d38b95d9f7ff50733f0d6b6b343866b6d1ccdff2a52b.jpeg",
    "https://cdn.faire.com/fastly/21a7777b659b28bbb5da7601c4ec4d09bd8299c6047c7e51fc3dda608e734b06.jpeg",
    "https://cdn.faire.com/fastly/1f5d75c2c1933df67239230e664ddeb1edf5f8dcac8283fc39d438036db686b8.jpeg",
    "https://cdn.faire.com/fastly/41c1db02f6dfc40f0a85b60063b031cab8489f99ec7d87c86731172702867272.jpeg",
    "https://cdn.faire.com/fastly/c157b5414aa27e42ce4cdd85fdeef930b72ae217c4cf415c87b71c768bebbfa3.jpeg",
    "https://cdn.faire.com/fastly/f702c273894f69f4870397c76de303f45d49f059f06b0061a2f39a9a0f333647.jpeg",
    "https://cdn.faire.com/fastly/9925e2b464888396a71ac7f0903be53b23c3dfaad0119face28a27bd2f31ce7c.jpeg",
    "https://cdn.faire.com/fastly/4532237fc0765a16f3859072c463ff42b46bb4449c75e4eaa2d67bf02dfe4a5a.jpeg",
    "https://cdn.faire.com/fastly/150e020c15a6ba4ab6d8232a28ef5e8dcab9fe2744afad52645c6bdc88d4101f.jpeg",
    "https://cdn.faire.com/fastly/f1ac04a5c8a6f679c74e9826a45ceb3a8f670bf9ccbf8653241813c64a1905c9.jpeg",
    "https://cdn.faire.com/fastly/87abba358a3356f1b028c8379b0a8a878b89956b308282b28ebf98ea867e7264.jpeg",
    "https://cdn.faire.com/fastly/e6815ca3eaeb660b3465d5c48a3fda208f753b1c0d5b3705f2222d9aa8b61b2b.jpeg",
  ],
  priceDollars: 1.39,
  description:
    "Mini Gemstone Puffy Hearts measuring 15mm are the perfect retail-ready crystals for your shop. Whether you run a metaphysical store, crystal boutique, or gift shop, these small polished hearts make ideal impulse buys, thoughtful gifts, or spiritual tools. Available in assorted natural gemstones, each puffy heart is carved and smooth to the touch, bringing a blend of beauty and metaphysical charm. These crystal hearts are perfect for pocket stones, altar décor, or crystal grids. Great for displays, gift boxes, and spiritual kits.\n\nSold individually with a minimum of 5 per style.\n",
  tags: [],
  msrpDollars: 2.77,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:25.749Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
